// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"201":"9e217581","632":"006ec671","833":"3a42998f","913":"26cf370b"}[chunkId] + ".chunk.css";
};